import { CircleAlert } from 'lucide-react'
import { useTranslation } from '../../../contexts/localization/Localization'
import useScrollHighlightedIntoView from '../../../hooks/useScrollHighlightedIntoView'
import { cn } from '@playbooks/ui/lib/utils'

// Highlight an assessment if it is required and has no chosen response or responses.
// This is used to indicate which assessments need attention.
export default function AssessmentHighlighter({ isFunnelView }: { isFunnelView: boolean }) {
  const { text } = useTranslation()
  const ref = useScrollHighlightedIntoView()
  return (
    <div
      ref={ref}
      data-highlighter-container
      className={cn(
        'absolute -top-2 -left-1 -right-1 -bottom-2 rounded-sm border-red-500/50 border',
        'flex flex-col items-end pointer-events-none z-1',
        !isFunnelView && '-left-2.5',
      )}
    >
      <h2
        data-testid="highlighter_label"
        className="relative -top-2 right-4 text-xs px-1 border-red-500 dark:bg-red-900 bg-red-500 text-white rounded-md flex items-center gap-1"
      >
        <CircleAlert className="" size={12} />
        {text('assessmentRequiredLabel')}
      </h2>
      <div className="absolute w-full h-full bg-red-500/5 rounded-md" />
    </div>
  )
}
